module.exports = __webpack_public_path__ + "56c432429ca04caec0d6387a338f7412.png";